// utils/authHelpers.ts

import { ROUTES } from "@/enums/routes";
import { userInfo } from "@/modules/authenticationService";
import { setDetail, setRole } from "@/store/redux/userDetailsSlice";
import { AppDispatch } from "@/store/store";
import axios from "axios";
import { NavigateFunction } from "react-router-dom";
import { ErrorHelper } from "./errorHelper";
import { toastMessage } from "./toastHelper";

export const fetchAndSetUserData = async (
  token: string,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
) => {
  try {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const data = await userInfo();

    dispatch(setDetail(data));
    dispatch(setRole(data));
    if (data.organizationId !== null) {
      navigate(ROUTES.DASHBOARD);
    } else {
      navigate(ROUTES.ORGANIZATION_FORM);
    }
  } catch (error) {
    const actualError = ErrorHelper(error);
    const message = Array.isArray(actualError) ? actualError[0] : actualError;
    toastMessage("error", message);
  }
};
